import React, { useEffect, useState } from 'react';
import Routes from './routes/Routes';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import Loader from './components/Loader';
import useAuth from './hooks/useAuth';
import i18next from 'i18next';
import './assets/scss/Theme.scss';
import './assets/scss/styling.css';

const App = () => {
    const [isInitializing, setIsInitializing] = useState(true);
    const { auth, setAuth } = useAuth();

    useEffect(() => {
        const initializeApp = async () => {
            try {
                await i18next.loadNamespaces(['translation']);

                if (!auth?.user) {
                    const response = await fetch("/accounts/is_auth", {
                        credentials: 'include'
                    });
                    if (response.ok) {
                        const data = await response.json();
                        setAuth(data);
                    }
                }
            } catch (error) {
                console.error('Failed to initialize app:', error);
            } finally {
                setIsInitializing(false);
                // Remove initial loader
                const initialLoader = document.getElementById('initial-loader');
                if (initialLoader?.parentNode) {
                    initialLoader.parentNode.removeChild(initialLoader);
                }
            }
        };

        initializeApp();
    }, [auth?.user, setAuth]);

    if (isInitializing) {
        return <Loader />;
    }

    return (
        <ErrorBoundary fallback={<h1>Oops! An error occurred. Please try again later.</h1>}>
            <Routes />
        </ErrorBoundary>
    );
};

export default App;